module.exports = __webpack_public_path__ + "static/media/export-icon.7d93ea1a.svg";